import * as React from 'react';
import { useEffect } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { useSystem } from '../../hooks/useSystem';
import { NotificationType } from '@foxbun/lib-goferal-types';
import { ButtonType, ButtonWidget, ButtonWidgetProps } from '../../widgets/controls/ButtonWidget';
import { AnimatePageWidget } from '../../widgets/layout/AnimatePageWidget';
import { EmptyWidget } from '../../widgets/content/EmptyWidget';
import { Font } from '../../fonts';

export const NotificationsPage: React.FC = observer(() => {
  const system = useSystem();
  let { notifications, loading } = system.session.userNotificationEngine;

  useEffect(() => {
    system.session.userNotificationEngine.loadNotifications();
  }, []);

  if (notifications.length === 0 && !loading) {
    return <EmptyWidget label="Bark! you are all caught up!" />;
  }

  return (
    <AnimatePageWidget slide={false}>
      <S.Container>
        {notifications.map((n) => {
          if (n.type === NotificationType.PACK_JOIN_REQUEST) {
            return (
              <UserNotificationWidget
                key={n._id.toString()}
                text={n.text}
                date={n.created_at}
                btns={[
                  {
                    label: 'Accept',
                    action: async () => {
                      await system.session.api_client.packs.acceptRequestToJoinPack({
                        _id: n.invite_id
                      });
                      await system.session.userNotificationEngine.loadNotifications();
                    }
                  },
                  {
                    label: 'Decline',
                    type: ButtonType.SECONDARY,
                    action: () => {}
                  }
                ]}
              />
            );
          }
          if (n.type === NotificationType.PACK_INVITATION) {
            return (
              <UserNotificationWidget
                key={n._id.toString()}
                text={n.text}
                date={n.created_at}
                btns={[
                  {
                    label: 'Accept',
                    action: async () => {
                      await system.session.api_client.packs.acceptPackInvite({
                        _id: n.invite_id
                      });
                      await system.session.userNotificationEngine.loadNotifications();
                    }
                  },
                  {
                    label: 'Decline',
                    type: ButtonType.SECONDARY,
                    action: () => {}
                  }
                ]}
              />
            );
          }
          return <S.Notification />;
        })}
      </S.Container>
    </AnimatePageWidget>
  );
});

export interface UserNotificationWidgetProps {
  text: string;
  date: Date;
  btns?: ButtonWidgetProps[];
}

export const UserNotificationWidget: React.FC<UserNotificationWidgetProps> = (props) => {
  return (
    <S.Notification>
      <S.Desc>{props.text}</S.Desc>
      {props.btns ? (
        <S.Buttons>
          {props.btns.map((b) => {
            return <ButtonWidget key={b.label} {...b} />;
          })}
        </S.Buttons>
      ) : null}
    </S.Notification>
  );
};

namespace S {
  export const Container = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  `;

  export const Buttons = styled.div`
    display: flex;
    align-items: center;
    column-gap: 5px;
  `;

  export const Desc = styled.div``;

  export const Notification = styled.div`
    display: flex;
    flex-direction: column;
    background: ${(p) => p.theme.user_notification.background};
    border-radius: 10px;
    padding: 10px 10px;
    font-family: ${Font.Normal};
    font-size: 14px;
    color: ${(p) => p.theme.user_notification.foreground};
    row-gap: 10px;
  `;
}
